<template>
    <div class="module">
        <header class="module__header">
            <a
                class="back-btn"
                @click="goBack('super-device-whitelist')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">Append to Whitelist</h1>
        </header>

        <section class="module__body">
            <form @submit.prevent="appendToWhitelist">
                <div class="form-group">
                    <label for="serial_numbers">Serial Numbers</label>
                    <textarea
                        id="serial_numbers"
                        v-model="serialNumbers"
                        required
                    />
                </div>

                <form-errors :response="errorResponse"></form-errors>

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :class="{ active: submitted }"
                    >
                        <div>Append</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'
import hasBackButton from '@/mixins/hasBackButton'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast, hasBackButton],

    data() {
        return {
            serialNumbers: null,
            errorResponse: null,
            submitted: false,
        }
    },

    methods: {
        appendToWhitelist() {
            this.submitted = true

            this.$http
                .post('device-whitelist', {
                    serial_numbers: this.serialNumbers,
                })
                .then(() => {
                    this.toast('Successfully appended device(s) to whitelist!')
                    this.$router.push('/device-whitelist')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
